var app = angular.module("leonardo");

var TemplateSelectorDialog = function($scope, $rootScope, ngDialog, TemplateService, FilterService, $timeout) {
  $scope.workflow = $scope.ngDialogData.workflow;
  $scope.templates = [];
  $scope.templatesSelected = [];

  angular.forEach($scope.workflow.templates, function(value){
    $scope.templatesSelected.push(value);
  });

  $scope.showAddNewDialog = function(){
    ngDialog.openConfirm({
      template: 'views/templates/dialog/workflow/item/add.html',
      controller: 'WorkFlowItemAddDialog',
      className: 'ngdialog-theme-default ngdialog-template-add',
      data: {
        template: null,
        action: 'create',
        workflow: $scope.workflow
      }
    }).then(function(template){
      $scope.refresh();
      $scope.toggleTemplate(template.id);
    }, function () {
      return;
    });
  };

  $scope.toggleTemplate = function(template_id){
    if (_.contains($scope.templatesSelected, template_id)) {
      $scope.templatesSelected.splice($scope.templatesSelected.indexOf(template_id), 1);
    }
    else {
      $scope.templatesSelected.push(template_id);
    }
  };

  $scope.templateSelected = function(template_id){
    return _.contains($scope.templatesSelected, template_id);
  };

  $scope.refresh = function() {
    var params = {disable_pagination: true};
    params['type'] = TemplateService.TYPE_ACCOUNT_WORKFLOW;
    TemplateService.getlist(params).then(function (list) {
      $scope.templates = list;
    });
  };

  $scope.submit = function(){
    $scope.confirm($scope.templatesSelected);
  };

  $timeout(function () {
    $scope.refresh();
  }, 0);
};

app.controller('TemplateSelectorDialog', ['$scope', '$rootScope', 'ngDialog', 'TemplateService', 'FilterService', '$timeout',
  TemplateSelectorDialog]);
